import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';


const TITLE = 'title';
const TOGGLE_TEXT = 'toggleText';
const LABEL = 'label';
const CONTENT = 'content';
const CAPTION = 'caption';
const ALT_TEXT = 'alt_text';
const TILE_CAPTION = 'tile_caption';
const LINK_TITLE = 'link_title';
const LINK_DESCRIPTION = 'link_description';
const ACCORDION_DATA = 'accordion_data';
const RENDERED_CAPTION = 'renderedCaption';
const RENDERED_TILE_CAPTION = 'renderedTileCaption';
const CUSTOM_FOOTER_HTML = 'customFooterHtml';
const HORIZONTAL_ALIGN = 'horizontal_align';
const VERTICAL_ALIGN = 'vertical_align';
const FONT_SIZE = 'font_size';

const TRANSLATABLE_FIELDS = [
  TITLE,
  TOGGLE_TEXT,
  LABEL,
  CONTENT,
  CAPTION,
  ALT_TEXT,
  TILE_CAPTION,
  LINK_TITLE,
  LINK_DESCRIPTION,
  ACCORDION_DATA,
  RENDERED_CAPTION,
  RENDERED_TILE_CAPTION,
  CUSTOM_FOOTER_HTML,
  HORIZONTAL_ALIGN,
  VERTICAL_ALIGN,
  FONT_SIZE
];

const IGNORE_KEYS = [
  'allThumbnails',
  'blocksData',
  'orderedMenuItemIds',
  'sectionOverridesBySectionId',
  'gridPositions',
  'socialLinks',
  'subpagesById',
  'css_classes_list',
  'overlay_css_classes_list',
  'tile_taxonomy',
  'slides',
  'translationsAppliedLanguages',
  'translationsSelectedLanguageIsos',
  'orderedContentUuids',
];

const isArray = (val)=> {
  if(Object.prototype.toString.call(val) === '[object Array]') {
    return true;
  }

  return false;
};

const isObject = (val)=> {
  if(Object.prototype.toString.call(val) === '[object Object]') {
    return true;
  }

  return false;
};

export const clean_state_obj = (state_obj)=> {
  const resp = {};

  for (const key in state_obj) {
    if (includes(IGNORE_KEYS, key)) {
      continue;
    }

    var current_val = state_obj[key];

    if (isObject(current_val)) {
      resp[key] = clean_state_obj(current_val);

    } else if (isArray(current_val)) {
      const resp_list = [];

      forEach(current_val, (val)=> {
        if (isObject(val)) {
          resp_list.push(clean_state_obj(val));
        } else {
          resp_list.push(val);
        }
      });

      resp[key] = resp_list;

    } else {
      if (!includes(TRANSLATABLE_FIELDS, key)) {
        continue;
      } else if (is_really_empty(current_val)) {
        continue;
      } else {
        resp[key] = current_val;
      }

    }

  }

  return remove_empty_fields(resp);
};


const remove_empty_fields = (state_obj)=> {
  var new_dict = {};

  forEach(state_obj, (v, k)=> {
    if (isObject(v)) {
      v = remove_empty_fields(v);
    }

    if (!is_really_empty(v)) {
      new_dict[k] = v;
    }
  });

  return new_dict;
};

// isEmpty thinks a number is empty so we need to have an explicit check
// against that to account for things like font_size
const is_really_empty = (val)=>
  isNil(val) || (isEmpty(val) && !isNumber(val));
